import { definitionReaders, type DefinitionReaders, type DefinitionRow } from './location-type-ambience';
import { phpJsonTruthy } from '../compile/php-json-values';
import { readItemUuidSlot } from '../compile/inventory-raw-readers';

const fields = ['default_environment', 'default_location_inside', 'default_min_population',
    'default_encounter_amb_id', 'default_encounter_amb_night_id', 'default_encounter_amb_weather_id'] as const;
export function locationDefaults(type: DefinitionRow | null, parent: DefinitionRow | null, read: DefinitionReaders = definitionReaders) {
    const values = Object.fromEntries(fields.map(key => {
        const own = type ? read.layer(type, key) : null;
        const inherited = parent ? read.layer(parent, key) : null;
        return [key, phpJsonTruthy(own) ? own : phpJsonTruthy(inherited) ? inherited : own ?? null];
    }));
    return { environment: readItemUuidSlot(values.default_environment), inside: values.default_location_inside === true || values.default_location_inside === 1
            || values.default_location_inside === '1' || values.default_location_inside === 'true',
        population: values.default_min_population ?? '',
        weather: '95D01E12-0C33-928F-4DE8-570AD806D10B',
        ambience: ['encounter_amb', 'encounter_amb_night', 'encounter_amb_weather'].map(prefix => ({
            control: prefix.replace('encounter_', 'location_') + '_id', id: readItemUuidSlot(values[`default_${prefix}_id`]),
        })) };
}
